// import { ServInstance } from "../config";
import axios from "axios";
import { showFileUploadFeedback } from "../utilities/fileUploadFeedback";

const servInstance = process.env.REACT_APP_BASE_URL;

// All upload forms send files as FormData, including forms that save the file
// together with other fields. Confirm the upload only after the API succeeds.
const containsFile = (data) => {
  if (typeof FormData === "undefined" || !(data instanceof FormData)) return false;
  for (const value of data.values()) {
    if (typeof Blob !== "undefined" && value instanceof Blob) return true;
  }
  return false;
};

axios.interceptors.response.use((response) => {
  const result = response.data;
  const failed = result?.success === false || result?.status === false;
  if (containsFile(response.config.data) && !failed) {
    showFileUploadFeedback("File uploaded successfully", true);
  }
  return response;
});

const api = {
  get: (URL, queryParams = {}) =>
    axios.get(servInstance + URL, queryParams).then((res) => res.data),
  post: (URL, reqData, authData = {}) =>
    axios.post(servInstance + URL, reqData, authData).then((res) => res.data),

  put: (URL, reqData = {}) =>
    axios.put(servInstance + URL, reqData).then((res) => res.data),

  delete: (URL, reqData = {}) =>
    axios.delete(servInstance + URL, reqData).then((res) => res.data),
};
export default api;
